<div class="section position-relative">
    <div class="section-top">
        <h3 class="section-title">General</h3>
        <div class="section-top-actions">
            <button type="button" class="btn btn-sm btn-warning pull-right ms-1" (click)="clearCache()"
                title="Curățare cache la nivel de sistem/aplicație">
                <i class="fa-solid fa-shield-halved"></i>
            </button>
        </div>
    </div>
    <div class="settings-container p-4">
        <!-- Setări Generale -->
        <div class="settings-section mb-3">
            <h4 class="section-subtitle">Setări Generale</h4>
            <form [formGroup]="generalForm">
                <div class="row">
                    <div class="col-md-3">
                        <mat-form-field appearance="fill" class="w-100">
                            <mat-label>Instituție selectată</mat-label>
                            <mat-select formControlName="institutie_selectata"
                                (openedChange)="onDirectieSelectClosed()">
                                <mat-form-field class="px-2 w-100 sticky-input">
                                    <input matInput [formControl]="directiiControl" (keydown)="$event.stopPropagation()"
                                        (click)="$event.stopPropagation()" />
                                </mat-form-field>

                                <mat-option *ngIf="filteredDirectii.length === 0" disabled>
                                    <span>No results found</span>
                                </mat-option>

                                <mat-option [value]="-1">-- Alegeți --</mat-option>
                                <mat-option *ngFor="let directie of filteredDirectii" [value]="directie.id">
                                    {{ directie.name }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="col-md-3">
                        <mat-form-field appearance="fill" class="w-100">
                            <mat-label>Denumire instituție/UAT</mat-label>
                            <input matInput type="text" formControlName="institutie_denumire">
                        </mat-form-field>
                    </div>
                    <div class="col-md-3">
                        <mat-form-field appearance="fill" class="w-100">
                            <mat-label>Email comunicare</mat-label>
                            <input matInput type="email" formControlName="email_comunicare">
                        </mat-form-field>
                    </div>
                    <div class="col-md-3">
                        <mat-form-field appearance="fill" class="w-100">
                            <mat-label>Website instituție/UAT</mat-label>
                            <input matInput type="text" formControlName="institutie_website">
                        </mat-form-field>
                    </div>
                </div>
                <div
                    *ngIf="generalModified && permissionsService.hasPermission('indoc-module.settings.general-settings.update')">
                    <button mat-raised-button color="primary" (click)="updateGeneral()">
                        Actualizare
                    </button>
                </div>
            </form>
        </div>

        <!-- Setări Default -->
        <div class="settings-section mb-3">
            <h4 class="section-subtitle">Setări Default</h4>
            <form [formGroup]="defaultForm">
                <div class="row">
                    <div class="col-md-6">
                        <mat-form-field appearance="fill" class="w-100">
                            <mat-label>Status Default</mat-label>
                            <mat-select formControlName="default_status">
                                <mat-option [value]="-1">-- Alegeți --</mat-option>
                                <mat-option *ngFor="let status of statuses" [value]="status.id">
                                    {{status.name}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>

                    <div class="col-md-6">
                        <mat-form-field appearance="fill" class="w-100">
                            <mat-label>Prioritate Default</mat-label>
                            <mat-select formControlName="default_priority">
                                <mat-option [value]="-1">-- Alegeți --</mat-option>
                                <mat-option *ngFor="let prioritate of priorities" [value]="prioritate.id">
                                    {{prioritate.name}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
                <div
                    *ngIf="defaultModified && permissionsService.hasPermission('indoc-module.settings.general-settings.update')">
                    <button mat-raised-button color="primary" (click)="updateDefault()">
                        Actualizare
                    </button>
                </div>
            </form>
        </div>

        <!-- Setări Registratura -->
        <div class="settings-section mb-3">
            <h4 class="section-subtitle">Setări Registratură</h4>
            <form [formGroup]="registraturaForm">
                <div class="row">
                    <div class="col-md-3">
                        <mat-form-field appearance="fill" class="w-100">
                            <mat-label>Registru oficial</mat-label>
                            <mat-select formControlName="registru_oficial" (openedChange)="onSerieSelectClosed()">
                                <mat-form-field class="px-2 w-100 sticky-input">
                                    <input matInput [formControl]="seriiControl" (keydown)="$event.stopPropagation()"
                                        (click)="$event.stopPropagation()" />
                                </mat-form-field>

                                <mat-option *ngIf="filteredSerii.length === 0" disabled>
                                    <span>No results found</span>
                                </mat-option>

                                <mat-option [value]="-1">-- Alegeți --</mat-option>

                                <mat-option *ngFor="let serie of filteredSerii" [value]="serie.id">
                                    {{ serie.name }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="col-md-3">
                        <mat-form-field appearance="fill" class="w-100">
                            <mat-label>Așteptare semnături</mat-label>
                            <mat-select formControlName="asteptare_semnaturi_status">
                                <mat-option [value]="-1">-- Alegeți --</mat-option>
                                <mat-option *ngFor="let status of statuses" [value]="status.id">
                                    {{status.name}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="col-md-3">
                        <mat-form-field appearance="fill" class="w-100">
                            <mat-label>De înregistrat SRP</mat-label>
                            <mat-select formControlName="de_inregistrat_srp_status">
                                <mat-option [value]="-1">-- Alegeți --</mat-option>
                                <mat-option *ngFor="let status of statuses" [value]="status.id">
                                    {{status.name}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="col-md-3">
                        <mat-form-field appearance="fill" class="w-100">
                            <mat-label>Închis/Closed Status</mat-label>
                            <mat-select formControlName="documents_to_close_status">
                                <mat-option [value]="-1">-- Alegeți --</mat-option>
                                <mat-option *ngFor="let status of statuses" [value]="status.id">
                                    {{status.name}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6">
                        <mat-form-field appearance="fill" class="w-100">
                            <mat-label>Status - Înregistrat (fără vreo operațiune)</mat-label>
                            <mat-select formControlName="registered_status">
                                <mat-option [value]="-1">-- Alegeți --</mat-option>
                                <mat-option *ngFor="let status of statuses" [value]="status.id">
                                    {{status.name}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="col-md-6">
                        <mat-form-field appearance="fill" class="w-100">
                            <mat-label>Serviciu Registratură/Principal</mat-label>
                            <mat-select formControlName="serviciu_registratura"
                                (openedChange)="onCompartimentSelectClosed()">
                                <mat-form-field class="px-2 w-100 sticky-input">
                                    <input matInput [formControl]="compartimenteControl"
                                        (keydown)="$event.stopPropagation()" (click)="$event.stopPropagation()" />
                                </mat-form-field>

                                <mat-option *ngIf="filteredCompartimente.length === 0" disabled>
                                    <span>No results found</span>
                                </mat-option>

                                <mat-option [value]="-1">-- Alegeți --</mat-option>

                                <mat-option *ngFor="let compartiment of filteredCompartimente"
                                    [value]="compartiment.id">
                                    {{ compartiment.name }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
                <div
                    *ngIf="registraturaModified && permissionsService.hasPermission('indoc-module.settings.general-settings.update')">
                    <button mat-raised-button color="primary" (click)="updateRegistratura()">
                        Actualizare
                    </button>
                </div>
            </form>
        </div>

        <!-- Setări AWB -->
        <div class="settings-section mb-3">
            <h4 class="section-subtitle">Setări AWB</h4>
            <form [formGroup]="awbForm">
                <div class="row">
                    <div class="col-md-3">
                        <mat-form-field appearance="fill" class="w-100">
                            <mat-label>Borderou activ</mat-label>
                            <input matInput type="text" formControlName="BORDEROU_ACTIV">
                        </mat-form-field>
                    </div>
                    <div class="col-md-3">
                        <mat-form-field appearance="fill" class="w-100">
                            <mat-label>Cod trimitere AWB</mat-label>
                            <input matInput type="text" formControlName="cod_trimitere_awb">
                        </mat-form-field>
                    </div>
                    <div class="col-md-3">
                        <mat-form-field appearance="fill" class="w-100">
                            <mat-label>ID EXTERN Oficiu poștal</mat-label>
                            <input matInput type="text" formControlName="oficiu_postal">
                        </mat-form-field>
                    </div>
                    <div class="col-md-3">
                        <mat-form-field appearance="fill" class="w-100">
                            <mat-label>Greutate standard(KG)</mat-label>
                            <input matInput type="text" formControlName="greutate">
                        </mat-form-field>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6">
                        <mat-form-field appearance="fill" class="w-100">
                            <mat-label>Status Poștă</mat-label>
                            <mat-select formControlName="status_posta">
                                <mat-option [value]="-1">-- Alegeți --</mat-option>
                                <mat-option *ngFor="let status of statuses" [value]="status.id">
                                    {{status.name}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="col-md-6">
                        <mat-form-field appearance="fill" class="w-100">
                            <mat-label>Status Expediție INDOC</mat-label>
                            <mat-select formControlName="status_indoc">
                                <mat-option [value]="-1">-- Alegeți --</mat-option>
                                <mat-option *ngFor="let status of statuses" [value]="status.id">
                                    {{status.name}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
                <div
                    *ngIf="awbModified && permissionsService.hasPermission('indoc-module.settings.general-settings.update')">
                    <button mat-raised-button color="primary" (click)="updateAwb()">
                        Actualizare
                    </button>
                </div>
            </form>
        </div>

        <!-- Expeditor -->
        <div class="settings-section mb-3">
            <h4 class="section-subtitle">Expeditor</h4>
            <form [formGroup]="expeditorForm">
                <div class="row">
                    <div class="col-md-3">
                        <mat-form-field appearance="fill" class="w-100">
                            <mat-label>Nume Expeditor</mat-label>
                            <input matInput type="text" formControlName="expeditor_nume">
                        </mat-form-field>
                    </div>
                    <div class="col-md-3">
                        <mat-form-field appearance="fill" class="w-100">
                            <mat-label>Persoană contact</mat-label>
                            <input matInput type="text" formControlName="expeditor_persoana_contact">
                        </mat-form-field>
                    </div>
                    <div class="col-md-3">
                        <mat-form-field appearance="fill" class="w-100">
                            <mat-label>Județ Expeditor</mat-label>
                            <mat-select formControlName="expeditor_judet"
                                (openedChange)="onJudeteExpeditorSelectClosed()"
                                (selectionChange)="onJudetExpeditorChange($event.value)">
                                <mat-form-field class="px-2 w-100 sticky-input">
                                    <input matInput [formControl]="judeteExpeditorControl"
                                        (keydown)="$event.stopPropagation()" (click)="$event.stopPropagation()" />
                                </mat-form-field>

                                <mat-option *ngIf="filteredJudeteExpeditor.length === 0" disabled>
                                    <span>No results found</span>
                                </mat-option>

                                <mat-option [value]="-1">-- Alegeți --</mat-option>

                                <mat-option *ngFor="let judet of filteredJudeteExpeditor" [value]="judet.id">
                                    {{ judet.name }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="col-md-3">
                        <mat-form-field appearance="fill" class="w-100">
                            <mat-label>Localitate Expeditor</mat-label>
                            <mat-select formControlName="expeditor_localitate">
                                <mat-form-field class="px-2 w-100 sticky-input">
                                    <input matInput [formControl]="localitatiExpeditorControl"
                                        (keydown)="$event.stopPropagation()" (click)="$event.stopPropagation()" />
                                </mat-form-field>

                                <mat-option *ngIf="showLocalitatiExpeditorMessage" disabled>
                                    <span
                                        *ngIf="!localitatiExpeditorControl.value || localitatiExpeditorControl.value.length < 2">
                                        Vă rugăm să introduceți 2 caractere sau mai multe
                                    </span>
                                    <span
                                        *ngIf="isLocalitatiExpeditorLoading && localitatiExpeditorControl.value.length >= 2">
                                        Se caută...
                                    </span>
                                    <span
                                        *ngIf="!isLocalitatiExpeditorLoading && localitatiExpeditorLoadComplete && localitatiExpeditor.length === 0 && localitatiExpeditorControl.value && localitatiExpeditorControl.value.length >= 2">
                                        Nu s-au găsit rezultate
                                    </span>
                                </mat-option>

                                <mat-option *ngFor="let localitate of localitatiExpeditor" [value]="localitate.id">
                                    {{ localitate.name }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-3">
                        <mat-form-field appearance="fill" class="w-100">
                            <mat-label>Adresă Expeditor</mat-label>
                            <input matInput type="text" formControlName="expeditor_adresa">
                        </mat-form-field>
                    </div>
                    <div class="col-md-3">
                        <mat-form-field appearance="fill" class="w-100">
                            <mat-label>Cod Poștal Expeditor</mat-label>
                            <input matInput type="text" formControlName="expeditor_cod_postal">
                        </mat-form-field>
                    </div>
                    <div class="col-md-3">
                        <mat-form-field appearance="fill" class="w-100">
                            <mat-label>Telefon Expeditor</mat-label>
                            <input matInput type="text" formControlName="expeditor_telefon">
                        </mat-form-field>
                    </div>
                    <div class="col-md-3">
                        <mat-form-field appearance="fill" class="w-100">
                            <mat-label>Email Expeditor</mat-label>
                            <input matInput type="email" formControlName="expeditor_email">
                        </mat-form-field>
                    </div>
                </div>
                <div
                    *ngIf="expeditorModified && permissionsService.hasPermission('indoc-module.settings.general-settings.update')">
                    <button mat-raised-button color="primary" (click)="updateExpeditor()">
                        Actualizare Expeditor
                    </button>
                </div>
            </form>
        </div>

        <!-- Adresă default -->
        <div class="settings-section">
            <h4 class="section-subtitle">Adresă default</h4>
            <form [formGroup]="adresaDefaultForm">
                <div class="row">
                    <div class="col-md-4">
                        <mat-form-field appearance="fill" class="w-100">
                            <mat-label>Țară</mat-label>
                            <mat-select formControlName="default_adresa_tara" (openedChange)="onTaraSelectClosed()"
                                (selectionChange)="onTaraChange($event.value)">
                                <mat-form-field class="px-2 w-100 sticky-input">
                                    <input matInput [formControl]="tariControl" (keydown)="$event.stopPropagation()"
                                        (click)="$event.stopPropagation()" />
                                </mat-form-field>

                                <mat-option *ngIf="filteredTari.length === 0" disabled>
                                    <span>No results found</span>
                                </mat-option>

                                <mat-option [value]="-1">-- Alegeți --</mat-option>
                                <mat-option *ngFor="let tara of filteredTari" [value]="tara.id">
                                    {{ tara.name }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="col-md-4">
                        <mat-form-field appearance="fill" class="w-100">
                            <mat-label>Județ</mat-label>
                            <mat-select formControlName="default_adresa_judet" (openedChange)="onJudeteSelectClosed()"
                                (selectionChange)="onJudetChange($event.value)">
                                <mat-form-field class="px-2 w-100 sticky-input">
                                    <input matInput [formControl]="judeteControl" (keydown)="$event.stopPropagation()"
                                        (click)="$event.stopPropagation()" />
                                </mat-form-field>

                                <mat-option *ngIf="filteredJudete.length === 0" disabled>
                                    <span>No results found</span>
                                </mat-option>

                                <mat-option [value]="-1">-- Alegeți --</mat-option>

                                <mat-option *ngFor="let judet of filteredJudete" [value]="judet.id">
                                    {{ judet.name }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="col-md-4">
                        <mat-form-field appearance="fill" class="w-100">
                            <mat-label>Localitate</mat-label>
                            <mat-select formControlName="default_adresa_localitate">
                                <mat-form-field class="px-2 w-100 sticky-input">
                                    <input matInput [formControl]="localitatiControl"
                                        (keydown)="$event.stopPropagation()" (click)="$event.stopPropagation()" />
                                </mat-form-field>

                                <mat-option *ngIf="showLocalitatiMessage" disabled>
                                    <span *ngIf="!localitatiControl.value || localitatiControl.value.length < 2">
                                        Vă rugăm să introduceți 2 caractere sau mai multe
                                    </span>
                                    <span *ngIf="isLocalitatiLoading && localitatiControl.value.length >= 2">
                                        Se caută...
                                    </span>
                                    <span
                                        *ngIf="!isLocalitatiLoading && localitatiLoadComplete && localitati.length === 0 && localitatiControl.value && localitatiControl.value.length >= 2">
                                        Nu s-au găsit rezultate
                                    </span>
                                </mat-option>

                                <mat-option *ngFor="let localitate of localitati" [value]="localitate.id">
                                    {{ localitate.name }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
                <div
                    *ngIf="adresaDefaultModified && permissionsService.hasPermission('indoc-module.settings.general-settings.update')">
                    <button mat-raised-button color="primary" (click)="updateAdresaDefault()">
                        Actualizare Adresă
                    </button>
                </div>
            </form>
        </div>
    </div>
    <div class="section-spinner position-absolute" *ngIf="isLoading">
        <div class="spinner position-absolute top-50 start-50 translate-middle">
            <mat-spinner></mat-spinner>
            <h3 class="mt-2">{{ helper.dialogConfig.generalMessages.pleaseWait }}</h3>
        </div>
    </div>
</div>